import newAccount from './newAccount.js';

/**
 *
 * BuyerUserInfo
 *
 * @namespace BuyerUserInfo
 */
newAccount.BuyerUserInfo = newAccount.BuyerUserInfo || {
    // ---------------------------------------------
    //
    //        Public Methods
    //
    // ---------------------------------------------

    /**
     * Constructor
     * @memberof BuyerUserInfo
     * @example
     * var keyValue = BuyerUserInfo.init(userInfo)
     * @param {object} userInfo
     */
    init: function(userInfo){
        if (userInfo){
            let userInfoItems = userInfo.split(',');

            this.firstName = this.getKeyValue('firstName:', userInfoItems);
            this.lastName = this.getKeyValue('lastName:', userInfoItems);
            this.companyName = this.getKeyValue('companyName:', userInfoItems);
        }
    },

    /**
     * @memberof BuyerUserInfo
     * @example
     * var userInfoStr = BuyerUserInfo.toString()
     * @returns {string} userInfoStr
     */
    toString: function(){
        let userInfoStr = "";

        userInfoStr = this.addFieldStr(userInfoStr, 'firstName:', this.firstName);
        userInfoStr = this.addFieldStr(userInfoStr, 'lastName:', this.lastName);
        userInfoStr = this.addFieldStr(userInfoStr, 'companyName:', this.companyName);

        return userInfoStr;
    },

    /**
     * @memberof BuyerUserInfo
     * @example
     * var buyerUserInfo = BuyerUserInfo.toJSON()
     * @returns {object} buyerUserInfo
     */
    toJSON: function(){
        let buyerUserInfo = {};

        buyerUserInfo.firstName = this.firstName;
        buyerUserInfo.lastName = this.lastName;
        buyerUserInfo.companyName = this.companyName;

        return buyerUserInfo;
    },

    /**
     * @memberof BuyerUserInfo
     * @example
     * BuyerUserInfo.isEmpty()
     * @returns {boolean} isEmpty
     */
    isEmpty: function(){
        return this.isFieldEmpty(this.firstName) &&
            this.isFieldEmpty(this.lastName) &&
            this.isFieldEmpty(this.companyName);
    },

    /**
     * @memberof BuyerUserInfo
     * @example
     * var keyValue = BuyerUserInfo.getKeyValue(key, userInfoItems)
     * @param {string} key
     * @param {object} userInfoItems
     * @returns {string} keyValue
     */
    getKeyValue: function(key, userInfoItems){
        let keyValue = "";

        if (userInfoItems.length > 0) {
            for (let i=0;i<userInfoItems.length;i++){
                if (userInfoItems[i].indexOf(key) > -1){
                    let lengthOfKey = key.length;

                    keyValue = userInfoItems[i].substr(lengthOfKey);
                    break;
                }
            }
        }

        return keyValue;
    },

    /**
     * @memberof BuyerUserInfo
     * @example
     * var userInfoStr = BuyerUserInfo.addFieldStr(userInfoStr, fieldLabel, fieldValue)
     * @param {string} userInfoStr
     * @param {string} fieldLabel
     * @param {string} fieldValue
     * @returns {string} userInfoStr
     */
    addFieldStr: function(userInfoStr, fieldLabel, fieldValue){
        if (fieldValue !== undefined && fieldValue.length > 0){
            if (userInfoStr.length > 0){
                userInfoStr += ',';
            }
            userInfoStr += fieldLabel + fieldValue;
        }
        return userInfoStr;
    },

    /**
     * @memberof BuyerUserInfo
     * @example
     * BuyerUserInfo.isFieldEmpty(fieldValue)
     * @param {string} fieldValue
     * @returns {boolean} isFieldEmpty
     */
    isFieldEmpty: function(fieldValue){
        return fieldValue === null || fieldValue === undefined || fieldValue.length === 0;
    }
};

export default newAccount.BuyerUserInfo;
